$(document).ready(() => {
  const $section = $('.inspiration-gallery-section');
  // Simulate loading state
  // $section.addClass('inspiration-gallery-section-active');

  // Optional: remove it after loading (example: after 2 seconds)
  setTimeout(() => {
    $section.addClass('inspiration-gallery-section-active');
  }, 500);

  //scroll animation

  $(() => {
  $('.inspiration-gallery-section-wrap .rich-text__wrapper .button').on('click', (e) => {
      e.preventDefault();

      const target = $('.template-blog .main-blog');

      if (target.length) {
        // Get CSS variables from root element
        const rootStyles = getComputedStyle(document.documentElement);
        const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height')) || 0;

        // Calculate total offset
        const offsetTop = target.offset().top - headerHeight - 30;

        $('html, body').animate({
          scrollTop: offsetTop
        }, 800);
      }
    });
  });
});
